import script from "./Records.vue?vue&type=script&setup=true&lang=ts"
export * from "./Records.vue?vue&type=script&setup=true&lang=ts"

import "./Records.vue?vue&type=style&index=0&id=4300a73e&scoped=true&lang=css"

import exportComponent from "/ws/7d23fcbcf8cf42679552365d2ccff9a6/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4300a73e"]])

export default __exports__